import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { AlertService } from "../_services";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HttpClient } from "@angular/common/http";
import { DomSanitizer } from "@angular/platform-browser";
import { EncryptionService } from "../_services/encryption.service";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { NewCommunityResourcesService } from "../_services/new-community-resources-service";
import { FilesService, SelectedFiles } from "../_services/files.service";
import { appConfig } from "../app.config";

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

class PartnerOffering {
  id: number;
  title: string;
  Comments: any;
  PostCategoryId: any;
  resource_url: any;
  resource_type: any;
  resources: [];
  resourcesName: [];
}

@Component({
  selector: "app-new-community-resources",
  templateUrl: "./new-community-resources.component.html",
  styleUrls: [],
})
export class NewCommunityResourcesComponent implements OnInit {
  @Input() allowMultiple: boolean;
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {}; //  DataTable
  dtTrigger = new Subject(); //  DataTable
  communityResourcesList: PartnerOffering[] = [];
  communityResourcesTotal: any;
  isSubmitted = false;
  displayedText: string = "";
  fileList: FileList | null = null;
  isEditMode: boolean = false;
  croppedImage: any = "";
  @Input() pdfTypeTitle: string = ".pdf";
  DisplayedText: string = "";
  @Input() required: boolean;
  start: number = 0;
  pageLength: number = 10;
  errorShow: any;
  selectedVerticals: any;
  categoryArr: any = [];
  resourcePdfArr: any = [];
  removePdfId: any;
  editpdfSrcTitle: any[] = [];
  mentionUserArr: any = [];
  pdfSrcTitle: any[] = [];
  pdfFileListTitle: any = [];
  public selectedFiles2: SelectedFiles[] = [];
  mentionUsers: any[] = [];
  mentionUsersSelected: any[] = [];
  getbaseUrl: any = "";

  getCommunityResources = {
    id: "",
    title: "",
    Comments: "",
    PostCategoryId: "",
    resource_type: "",
    resource_url: "",
  };

  constructor(
    public router: Router,
    private dataService: NewCommunityResourcesService,
    private alertService: AlertService,
    private modalService: NgbModal,
    private http: HttpClient,
    private files: FilesService,
    private enc_dec: EncryptionService,
    private sanitizer: DomSanitizer
  ) {
    this.getbaseUrl = appConfig.webUrl;
  }

  community_resources = {
    id: "",
    title: "",
    Comments: "",
    PostCategoryId: "",
    resource_url: "",
    resource_type: "file",
  };

  modalReference: NgbActiveModal;
  modalTitle: string;
  showloding = true;
  lodingImage = false;
  isEndDateInvalid: boolean = false;

  ngOnInit() {
    this.loadHide();
    window.scroll(0, 0);

    this.getResourcesList();

    this.dataService
      .resourcesMaster()
      .pipe()
      .subscribe((master) => {
        this.categoryArr = master.data;
      });
  }

  getResourcesList() {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: this.pageLength,
      serverSide: true,
      processing: true,
      order: [[2, "desc"]],
      ajax: (dataTablesParameters: any, callback) => {
        this.start = dataTablesParameters.start;
        this.pageLength = dataTablesParameters.length;

        this.http
          .post<DataTablesResponse>(
            "/api/list-community-resources",
            {
              req_data: this.enc_dec.encrypt(
                JSON.stringify(Object.assign(dataTablesParameters))
              ),
            },
            {}
          )
          .subscribe((response: any) => {
            const output = this.enc_dec.decrypt(response.res_data);
            const resp = JSON.parse(output);

            this.communityResourcesList = resp.data;

            this.communityResourcesTotal = resp["recordsTotal"];

            callback({
              recordsTotal: resp["recordsTotal"],
              recordsFiltered: resp["recordsFiltered"],
              data: [],
            });
          });
      },
      columns: [
        { data: "id" },
        { data: "title" },
        { data: "Comments" },
        { data: "category_name" },
      ],
    };
  }

  onViewMentionUsers(item, mentionuser) {
    const table = $("#partneroffertable").DataTable();
    table.ajax.reload(null, false);
    this.modalTitle = "Mention Users List";

    this.modalReference = this.modalService.open(mentionuser, {
      backdrop: "static",
      keyboard: false,
    });

    this.mentionUserArr = item.getMentions;
  }

  truncate(value: any, limit: any) {
    if (!value) return "";
    if (value.length > limit) {
      return value.substring(0, limit) + "...";
    }
    return value;
  }

  isFieldsInvalid(value: string): boolean {
    return !value || value.trim().length === 0;
  }

  open(content) {
    this.croppedImage = "";
    this.isSubmitted = false;
    this.mentionUsers = [];
    this.mentionUsersSelected = [];
    this.pdfSrcTitle = [];
    this.editpdfSrcTitle = [];

    if (this.getCommunityResources.id != null) {
      this.getCommunityResources.id = "";
    }

    this.community_resources.id = "";
    this.community_resources.title = "";
    this.community_resources.Comments = "";
    this.community_resources.resource_type = "file";
    this.community_resources.resource_url = "";
    this.community_resources.PostCategoryId = "";
    this.modalTitle = "Add Community Resources";
    this.modalReference = this.modalService.open(content, {
      backdrop: "static",
      keyboard: false,
    });
  }

  save(val, f) {
    this.isSubmitted = true;
    if (this.isEditMode) {
      if (
        this.community_resources.resource_type == "file" &&
        this.editpdfSrcTitle.length === 0 &&
        this.pdfValues.length === 0
      ) {
        this.alertService.error("Please upload a resource file");
        document
          .querySelector(".modal")
          .scrollTo({ top: 0, behavior: "smooth" });
        return;
      } else {
      }
    } else {
      if (
        this.community_resources.resource_type == "file" &&
        (!this.pdfValues || this.pdfValues.length === 0)
      ) {
        this.alertService.error("Please upload a resource file");
        document
          .querySelector(".modal")
          .scrollTo({ top: 0, behavior: "smooth" });
        return;
      }
    }

    if (
      this.community_resources.resource_type == "url" &&
      !this.community_resources.resource_url
    ) {
      this.alertService.error("Resource URL field is required");
      document.querySelector(".modal").scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (f.form.valid) {
      this.insertAction(val, f);
    } else {
    }
  }

  pdfChangeTitle(event: any) {
    this.pdfFileListTitle = event.target.files;
    let hasFiles = this.pdfFileListTitle && this.pdfFileListTitle.length > 0;
    if (hasFiles) {
      let validFiles: File[] = [];
      let invalidFiles: File[] = [];
      for (let i = 0; i < this.pdfFileListTitle.length; i++) {
        const file = this.pdfFileListTitle[i];
        var extension = file.name.substring(file.name.lastIndexOf("."));
        // Only process image files.
        var validFileType = this.pdfTypeTitle;

        if (
          validFileType.toLowerCase().indexOf(extension) < 0 ||
          file.size > 5000000
        ) {
          invalidFiles.push(file);
        } else {
          validFiles.push(file);
        }
      }
      if (invalidFiles.length > 0) {
        alert(
          "Please select valid file type and ensure file size is not more than 5 MB."
        );
        this.pdfFileListTitle = null;
        this.DisplayedText = "";
        event.target.value = "";
        return false;
      }
      let multipleFile = validFiles.length > 1;
      if (multipleFile) {
        this.DisplayedText = validFiles.length + " file(s) have been selected";
      } else {
        let file: File = validFiles[0];
        this.DisplayedText = file.name;
      }

      this.selectedFiles2 = [];
      this.files
        .toBase64(event.target.files, this.selectedFiles2)
        .subscribe((res) => {
          if (res && res.length > 0) {
            this.selectedFiles2 = res;
            // console.log(this.selectedFiles2, 'this.selectedFiles2');
            for (const selectedFile of this.selectedFiles2) {
              const url = selectedFile.base64 as string;
              this.pdfSrcTitle.push({
                key: "pdf",
                value: url,
                name: selectedFile.name as string,
                type: "base",
              });
            }
          }
        });
    }
    return false;
  }

  edit(id, content, item) {
    this.isEditMode = true;

    this.isEndDateInvalid = false;
    this.editpdfSrcTitle = [];
    this.pdfSrcTitle = [];
    this.removePdfId = "";
    this.loadShow();

    const data = {
      newsPostId: id,
    };

    this.dataService.editResources(data).subscribe((res) => {
      this.getCommunityResources = res["data"];
      this.mentionUsersSelected = res.data.getMentions.map(
        (user: any) => user.id
      );
      this.mentionUsers = res.data.getMentions ? res.data.getMentions : [];

      if (res.data.pdfs.length === 0) {
        this.community_resources.resource_type = "url";
      } else {
        this.community_resources.resource_type = "file";
      }

      if (res.data.pdfs) {
        if (Array.isArray(res.data.pdfs)) {
          res.data.pdfs.forEach((e: any) => {
            this.editpdfSrcTitle.push({
              key: e.id,
              value: e.imagepath,
              name: e.imagename,
              test: e.newspostId,
              type: "array",
            });
          });
        }
      }

      this.community_resources = {
        id: this.getCommunityResources.id,
        title: this.getCommunityResources.title,
        Comments: this.getCommunityResources.Comments,
        PostCategoryId: this.getCommunityResources.PostCategoryId,
        resource_url: this.getCommunityResources.resource_url,
        resource_type: this.community_resources.resource_type,
      };

      this.loadHide();
      this.modalTitle = "Edit Community Resources";

      this.modalReference = this.modalService.open(content, {
        backdrop: "static",
        keyboard: false,
      });
    });
  }

  removePdf(item: any, fileInput: HTMLInputElement) {
    this.pdfSrcTitle = this.pdfSrcTitle.filter((i) => i !== item);
    fileInput.value = "";
  }

  removeEditPdf(item: any) {
    this.editpdfSrcTitle = this.editpdfSrcTitle.filter((i) => i !== item);

    if (item.key) {
      this.removePdfId = this.removePdfId
        ? this.removePdfId + "," + item.key
        : item.key;
    }
  }

  onChangeResource(event: any) {
    const e = event.target.value;
    if (e == "1") {
      this.community_resources.resource_url = "";
    } else {
      this.pdfSrcTitle = [];
      this.editpdfSrcTitle = [];

      this.displayedText = "";
    }
  }

  get pdfValues() {
    return this.pdfSrcTitle
      .filter((item) => item.type === "base")
      .map((item) => item.value);
  }

  get pdfValuesName() {
    return this.pdfSrcTitle
      .filter((item) => item.type === "base")
      .map((item) => item.name);
  }

  insertAction(val, f) {
    var formData: any = {};
    formData.title = this.community_resources.title;
    formData.Comments = this.community_resources.Comments;
    formData.PostCategoryId = this.community_resources.PostCategoryId;
    formData.resource_url = this.community_resources.resource_url;
    formData.resource_type = this.community_resources.resource_type;
    formData.resources = this.pdfValues;
    formData.resourcesName = this.pdfValuesName;
    formData.mention_users = this.mentionUsersSelected.join(",") || "";

    if (formData.resource_url != "") {
      formData.resources = [];
      formData.resourcesName = [];
    }

    if (val.id === "") {
      this.loadShow();
      this.dataService.createResources(formData).subscribe(
        (data) => {
          this.loadHide();
          if (data["status"] === 200) {
            this.alertService.success(
              "Community Resources created successfully",
              true
            );

            const table = $("#partneroffertable").DataTable();
            table.ajax.reload(null, false);

            this.modalReference.close();
          } else {
            this.alertService.error(data.mesg);
            const modalElement = document.querySelector(".modal");
            if (modalElement) {
              modalElement.scrollTo({ top: 0, behavior: "smooth" });
            }
          }
        },
        (error) => {
          this.loadHide(); // Hide loader on error
          this.alertService.error(error);
        }
      );
    } else {
      formData.newsPostId = val.id;
      formData.deletedNewsPostpdfId = this.removePdfId;
      if (formData.resource_url != "") {
        formData.deletedNewsPostpdfId = "";
      }

      this.loadShow();

      this.dataService.updateResources(formData).subscribe(
        (data) => {
          this.loadHide();
          if (data["status"] == 200) {
            this.alertService.success(
              "Community Resources updated successfully",
              true
            );
            this.modalReference.close();
            const table = $("#partneroffertable").DataTable();
            table.ajax.reload(null, false);
          } else {
            this.alertService.error(data.msg);
            const modalElement = document.querySelector(".modal");
            if (modalElement) {
              modalElement.scrollTo({ top: 0, behavior: "smooth" });
            }
          }
        },
        (error) => {
          this.loadHide();
          this.alertService.error(error);
        }
      );
    }
  }

  filterMentions(event: any) {
    const searchTerm = event.term || "";

    if (searchTerm.length < 2) {
      this.mentionUsers = [];
      return;
    }

    this.dataService.communityMentionList(searchTerm).subscribe(
      (res: any) => {
        if (res.status === 200) {
          this.mentionUsers = res.list;
        }
      },
      (error) => {
        console.error("Error fetching users:", error);
      }
    );
  }

  getRowNumber(index: number): number {
    return this.start + index + 1;
  }

  delete(item) {
    this.loadShow();
    this.dataService
      .deleteResource(item.id)
      .pipe()
      .subscribe(
        (data) => {
          if (data["status"] == 200) {
            this.alertService.success(
              "Community Resources deleted successfully",
              true
            );
            item.inactive = item.inactive === "Y" ? "N" : "Y";
            this.loadHide();
          } else {
            this.alertService.error("Community Resources error");
          }
        },
        (error) => {
          this.alertService.error(error);
        }
      );
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }
}
